/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc>): BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc(), model);
        BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc>): BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc.newInstance(<BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDimensionGraphDBSyncAdhoc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * CoreStack master account owning the dimensions being backfilled (GraphDB repo + named-graph scope).
     */
    master_account_id: string;

}
